import React from 'react';
import PropTypes from 'prop-types';

const Card = ({ padding, className, children, ...otherProps }) => {
    return (
        <div
            className={`${className || ''} ${padding ? 'p-2' : ''}`}
            {...otherProps}>
            {children}
        </div>
    );
};
Card.propTypes = {
    padding: PropTypes.bool
};
Card.defaultProps = {
    padding: true
};

const Heading = ({ className, children, ...otherProps }) => {
    return (
        <h2
            className={`${
                className || ''
            } text-styled font-weight-bold text-center mb-2`}
            {...otherProps}>
            {children}
        </h2>
    );
};

const Footer = ({ className, children, ...otherProps }) => {
    return (
        <div
            className={` ${className || ''} text-center mt-1 pb-5`}
            {...otherProps}>
            {children}
        </div>
    );
};

export { Card, Heading, Footer };
